import { render, staticRenderFns } from "./CourseVideoThumb.vue?vue&type=template&id=492065a5&scoped=true"
import script from "./CourseVideoThumb.vue?vue&type=script&lang=js"
export * from "./CourseVideoThumb.vue?vue&type=script&lang=js"
import style0 from "./CourseVideoThumb.vue?vue&type=style&index=0&id=492065a5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "492065a5",
  null
  
)

export default component.exports